import className from 'classnames/bind';

import styles from './BrandChip.module.scss';
import { useMemo } from 'react';
const cx = className.bind(styles);

interface BrandChipProps {
  label: string;
  value: string;
  count?: number;
  active?: boolean;
  onClick?: (value: string) => void;
  className?: string;
}

export default function BrandChip({ label, value, count, onClick, className, active }: BrandChipProps) {

  const disabled = useMemo(() => {
    if (!isNaN(count)) return count === 0;
    return false;
  }, [count]);
  
  return (
    <button
      aria-current={active ? 'true' : 'false'}
      className={cx(["brand-chip", { active }, className])}
      disabled={disabled}
      onClick={() => onClick?.(value)}
    >
      <span className={cx("label", "cta")}>
        {label}
        {typeof count === 'number' && !disabled ? ` (${count})` : null}
      </span>
    </button>
  )
}